import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faExclamationCircle,
	faCheckCircle,
	faQuestionCircle,
	faInfoCircle as faInfoCircleSolid
} from '@fortawesome/pro-solid-svg-icons'
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons'
import type { Position } from '@syncfusion/ej2-react-popups'
import { TooltipComponent } from '@syncfusion/ej2-react-popups'
import type { IconProp } from '@fortawesome/fontawesome-svg-core'

export const WhatsThisStyles = {
	success: {
		badgeVariant: 'success',
		icon: faCheckCircle,
		color: '#4FC0B0'
	},
	info: {
		badgeVariant: 'info',
		icon: faInfoCircle,
		color: '#073d57'
	},
	infoHeader: {
		badgeVariant: 'info',
		icon: faInfoCircle,
		color: '#6B7280'
	},
	warning: {
		badgeVariant: 'danger',
		icon: faExclamationCircle,
		color: '#F86866'
	},
	help: {
		badgeVariant: 'info',
		icon: faQuestionCircle,
		color: '#073d57'
	},
	infoSolid: {
		badgeVariant: 'info',
		icon: faInfoCircleSolid,
		color: '#fff'
	}
}

interface IWhatsThis {
	id?: string
	style?: {
		badgeVariant: string
		icon: IconProp
		color: string
	} | null
	title?: string
	content: string
	verticalAlign?: 'baseline' | 'sub' | 'super' | 'unset'
	cssClass?: string
	position?: Position
}

const WhatsThis = (properties: IWhatsThis) => {
	const {
		id = '',
		style = null,
		title = '',
		content,
		verticalAlign = 'super',
		cssClass = '',
		position
	} = properties
	const tooltipContent = `<div>
			${title ? `<h4 className='mb-2'>${title}</h4>` : ''}
			<p>${content}</p>
		</div>`

	return (
		<TooltipComponent
			content={tooltipContent}
			position={position || 'TopCenter'}
			id={`whats-this-${id}`}
			tabIndex={0}
			cssClass={cssClass}
		>
			<div className={`ml-1 inline-block align-${verticalAlign}`}>
				<FontAwesomeIcon
					className={style?.color ?? 'text-gray-500'}
					icon={style?.icon ?? faInfoCircle}
				/>
			</div>
		</TooltipComponent>
	)
}

export default WhatsThis
